var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14.6351L10.8215 16.3951L14.75 11.9951",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9943C1 6.80881 1 4.21609 2.61092 2.60518C3.97582 1.24027 6.04556 1.03183 9.8 1M23 11.9943C23 6.80881 23 4.21609 21.389 2.60518C20.0242 1.24027 17.9544 1.03183 14.2 1",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 22.9945C6.71971 22.9945 5.17957 22.9945 4.00306 22.395C2.96816 21.8678 2.12676 21.0264 1.59947 19.9915C1 18.815 1 17.2749 1 14.1945C1 11.1142 1 9.5741 1.59947 8.39759C2.12676 7.3627 2.96816 6.52129 4.00306 5.994C5.17957 5.39453 6.71971 5.39453 9.8 5.39453H14.2C17.2803 5.39453 18.8204 5.39453 19.997 5.994C21.0319 6.52129 21.8733 7.3627 22.4005 8.39759C23 9.5741 23 11.1142 23 14.1945C23 17.2749 23 18.815 22.4005 19.9915C21.8733 21.0264 21.0319 21.8678 19.997 22.395C18.8204 22.9945 17.2803 22.9945 14.2 22.9945",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list_icon.a6d22573df60f587636fbc62d43d08bb.svg";
export { ForwardRef as ReactComponent };